module.exports = __webpack_public_path__ + "img/customer_05.18af8162.jpg";